module.exports = __webpack_public_path__ + "static/img/event10.ac409a3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/event10.png
// module id = LJEo
// module chunks = 1